<template>
	<section class="google-reviews">
		<div class="wrapper">
			<google-reviews @callback="callback()"/>
		</div>
	</section>
</template>

<script>
	export default {
		methods: {
			callback() {
				this.$scrollTo('header');
			}
		}
	}
</script>

<style lang="scss">

	.google-reviews .button {
		border: none;
	}
</style>
